import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { RTLProps } from "../../../shared/prop-types/ReducerProps";

const rows = [
	{ id: "full_street_address", disablePadding: false, label: "Address", noSort: true },
	{ id: "doc_type", disablePadding: false, label: "Doc Type", noSort: true },
	{ id: "document_date", disablePadding: false, label: "Document Date" },
	{ id: "recorded_datetime", disablePadding: false, label: "Recorded Date" },
	{ id: "document_amt", disablePadding: false, label: "Amount" },
	{ id: "party_1", disablePadding: false, label: "Borrower", noSort: true },
	{ id: "party_2", disablePadding: false, label: "Lender", noSort: true },
	{ id: "document_id", disablePadding: false, label: "Document", noSort: true },
];

class FinancingsSearchTableHead extends PureComponent {
	static propTypes = {
		onRequestSort: PropTypes.func.isRequired,
		order: PropTypes.string.isRequired,
		orderBy: PropTypes.string.isRequired,
		rtl: RTLProps.isRequired,
	};

	createSortHandler = (property) => (event) => {
		const { onRequestSort } = this.props;
		onRequestSort(event, property);
	};

	render() {
		const { order, orderBy, rtl } = this.props;
		return (
			<TableHead>
				<TableRow>
					{rows.map((row) => (
						<TableCell
							className="material-table__cell material-table__cell--sort material-table__cell-right"
							key={row.id}
							align={rtl.direction === "rtl" ? "right" : "left"}
							padding={row.disablePadding ? "none" : "default"}
							sortDirection={orderBy === row.id ? order : false}
						>
							{row.noSort ? (
								<span>{row.label}</span>
							) : (
								<TableSortLabel
									active={orderBy === row.id}
									direction={order}
									onClick={this.createSortHandler(row.id)}
									className="material-table__sort-label"
								>
									{row.label}
								</TableSortLabel>
							)}
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		);
	}
}

export default connect((state) => ({ rtl: state.rtl }))(FinancingsSearchTableHead);
